"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _lastMileDeliveryPricerite = require("@/mixins/last-mile-delivery-pricerite/last-mile-delivery-pricerite");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDTransferOrderModalComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDTransferOrderModalComponent, _Mixins);

  var _super = _createSuper(LMDTransferOrderModalComponent);

  function LMDTransferOrderModalComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDTransferOrderModalComponent);
    _this = _super.apply(this, arguments);
    _this.openMapModal = false;
    _this.location = {};
    _this.mapPoints = [];
    _this.selectedShipRefs = [];
    _this.colorByPlanId = [];
    _this.fromTrucks = [];
    _this.currentPlanId = null;
    _this.targetTruck = null;
    _this.targetPlanId = 'newPlanId';
    _this.popperOptions = {
      boundariesElement: 'body',
      gpuAcceleration: false
    };
    _this.dragOptions = {
      group: 'masterpointId',
      ghostClass: 'ghost',
      animation: 300,
      filter: '.disabled',
      onMove: function onMove(e) {
        return !e.related.classList.contains('disabled');
      }
    };
    _this.routeIndex = null;
    _this.latestStartTime = null;
    _this.isLoading = false;
    return _this;
  }

  (0, _createClass2.default)(LMDTransferOrderModalComponent, [{
    key: "onVisibilityChanges",
    value: function onVisibilityChanges(newVal, oldVal) {
      this.openMapModal = newVal;

      if (newVal && this.$selectedTruck) {
        if (this.$selectedTruck) {
          this.fromTrucks = [this.$selectedTruck];
          var truckData = this.getRoutes(this.$selectedTruck);
          this.initMap(truckData);
        } else {
          this.fromTrucks = [];
        }
      }
    }
  }, {
    key: "onRoutesChange",
    value: function onRoutesChange(newVal) {
      this.initMap(newVal);
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }, {
    key: "isDragRouteDisabled",
    get: function get() {
      return true;
      /*const hasLockedOrCompletedRoute = this.helper.some(this.mapPoints, route => route.locked || route.status.toUpperCase() === 'COMPLETED');
           return (
        this.fromTrucks.length > 1 ||
        hasLockedOrCompletedRoute ||
        !this.currentPlanId
      );*/
    }
  }, {
    key: "isRemoveOrdersDisabled",
    get: function get() {
      return (// this.isAutoAssign ||
        this.$anyChanges || this.selectedShipRefs.length === 0 || // this.areSomeRoutesStatusCompleted ||
        this.hasCompletedWaypoint
      );
    }
  }, {
    key: "isTransferLoadPlanDisabled",
    get: function get() {
      return (// this.isAutoAssign ||
        this.$anyChanges || this.selectedShipRefs.length === 0 || this.fromTrucks.length === 0 || !this.targetTruck || !this.targetPlanId || this.areSomeRoutesStatusCompleted || this.hasCompletedWaypoint || this.isTargetTruckRoutesAssignedCompleted
      );
    }
  }, {
    key: "areSomeRoutesStatusCompleted",
    get: function get() {
      var _this2 = this;

      if (!this.$plan || !this.$plan.trucks || !this.$plan.trucks.length) {
        return false;
      }

      var areSomeStatusCompleted = false;
      var filteredTrucks = this.$plan.trucks.filter(function (truck) {
        return _this2.fromTrucks.includes(truck.truckId);
      });
      this.helper.forEach(filteredTrucks, function (truck) {
        var bool = _this2.helper.some(truck.routes, function (r) {
          var intersect = _this2.helper.intersection(r.shipmentReference, _this2.selectedShipRefs);

          if (intersect.length > 0 && (r.status.toUpperCase() === 'ARRIVED' || r.status.toUpperCase() === 'ASSIGNED' || r.status.toUpperCase() === 'COMPLETED')) {
            areSomeStatusCompleted = true;
            return true;
          } else {
            return false;
          }
        }); // break


        if (bool) {
          return false;
        }
      });
      return areSomeStatusCompleted;
    }
  }, {
    key: "hasCompletedWaypoint",
    get: function get() {
      var _this3 = this;

      if (!this.$plan || !this.$plan.orders || !this.$plan.orders.length) {
        return false;
      }

      var hasCompletedWaypoint = false;
      var unassignedOrders = this.$plan.orders.filter(function (i) {
        return _this3.selectedShipRefs.includes(i.shipmentReference);
      });
      this.helper.forEach(unassignedOrders, function (order) {
        if (_this3.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          hasCompletedWaypoint = true;
          return false;
        }
      });
      return hasCompletedWaypoint;
    }
  }, {
    key: "isTargetTruckRoutesAssignedCompleted",
    get: function get() {
      var _this4 = this;

      var routes = this.getRoutes(this.targetTruck).filter(function (i) {
        return i['planId'] === _this4.targetPlanId;
      }) || [];
      var filteredRoutes = routes.find(function (tData) {
        return tData['status'].toUpperCase() === 'ASSIGNED' || tData['status'].toUpperCase() === 'ARRIVED' || tData['status'].toUpperCase() === 'COMPLETED';
      });
      return this.targetTruck && this.targetPlanId && routes.length > 0 && !this.helper.isEmptyObject(filteredRoutes);
    }
  }, {
    key: "fromPlanIds",
    get: function get() {
      if (this.fromTrucks.length) {
        return this.helper.uniq(this.mapPoints.filter(function (i) {
          return i.isFrom;
        }).map(function (i) {
          return i.planId;
        }));
      }

      return [];
    }
  }, {
    key: "truckIds",
    get: function get() {
      var trucks = this.helper.get(this.$plan, 'trucks', []);
      return trucks.length === 0 ? [] : trucks.map(function (i) {
        return i.truckId;
      });
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleModalClose",
    value: function handleModalClose() {
      this.$emit('modalClose');
      this.openMapModal = false;
      this.selectedShipRefs = [];
      this.currentPlanId = null;
      this.targetTruck = null;
      this.targetPlanId = 'newPlanId';
    }
  }, {
    key: "isRouteDisabled",
    value: function isRouteDisabled(route) {
      return route.locked || route.status.toUpperCase() === 'COMPLETED';
    }
  }, {
    key: "isRouteLast",
    value: function isRouteLast(route, points) {
      if (this.helper.isUndefined(route) || points.length === 0) {
        return false;
      }

      var isRouteLast = false;
      var routeIndex = this.helper.findIndex(points, function (i) {
        return i.code === route.code && i.orderId.toString() === route.orderId.toString();
      });

      if (routeIndex === -1) {
        return false;
      }

      if (routeIndex === points.length - 1) {
        isRouteLast = true;
      } else if (routeIndex !== 0) {
        isRouteLast = route.planId === points[routeIndex - 1].planId && route.planId !== points[routeIndex + 1].planId;
      }

      return isRouteLast;
    }
  }, {
    key: "getRouteIndex",
    value: function getRouteIndex(route) {
      var isFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var points = this.mapPoints.filter(function (r) {
        return r.isFrom === isFrom;
      });
      var routeIndex = this.helper.findIndex(points, function (i) {
        return i.code === route.code && i.orderId.toString() === route.orderId.toString();
      });
      return isFrom ? routeIndex + 1 : routeIndex + 1 + this.mapPoints.filter(function (r) {
        return r.isFrom;
      }).length;
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route) {
      var cursorStyle = this.isPlanIdBelongToDifferentUser(this.currentPlanId) || this.isDragRouteDisabled ? 'initial' : 'move';
      return {
        cursor: cursorStyle
      };
    }
  }, {
    key: "getRouteClass",
    value: function getRouteClass(route, routeIndex) {
      if (!route) {
        return {};
      }

      var fromPoints = this.mapPoints.filter(function (r) {
        return r.isFrom;
      });
      var intersect = this.helper.intersection(route.shipmentReference, this.selectedShipRefs);
      return (0, _defineProperty2.default)({
        'first-child': this.isShowPlateNumber({
          route: route,
          routeIndex: routeIndex
        }),
        'last-child': this.isRouteLast(route, fromPoints),
        disabled: this.isRouteDisabled(route),
        selected: intersect.length > 0
      }, route.status, true);
    }
  }, {
    key: "getTargetRouteStyles",
    value: function getTargetRouteStyles(route) {
      return {
        cursor: 'initial'
      };
    }
  }, {
    key: "getTargetRouteClass",
    value: function getTargetRouteClass(route) {
      var toPoints = this.mapPoints.filter(function (r) {
        return !r.isFrom;
      });
      return (0, _defineProperty2.default)({
        'last-child': this.isRouteLast(route, toPoints),
        disabled: this.isRouteDisabled(route)
      }, route.status, true);
    }
  }, {
    key: "getOrderId",
    value: function getOrderId(route) {
      return parseInt(route.masterpointId.split('-')[0], 10) || null;
    }
  }, {
    key: "getTimeWindow",
    value: function getTimeWindow(route) {
      var startTime = this.getWaypointFromId(route.masterpointId, 'startTime');

      if (this.helper.isUndefined(startTime)) {
        return '';
      }

      var date = this.helper.convertTimezone(startTime, this.$timezone, 'YY-MM-DD');
      var time = this.getStartAndEndTime(route.waypointId);
      return "".concat(date, " ").concat(time);
    }
  }, {
    key: "getActualFinishDate",
    value: function getActualFinishDate(route) {
      var completedTime = this.getWaypointFromId(route.masterpointId, 'completedTime');

      if (this.helper.isUndefined(completedTime) || completedTime === '0000-00-00 00:00:00') {
        return '';
      }

      return this.helper.convertTimezone(completedTime, this.$timezone);
    }
  }, {
    key: "getStartAndEndTime",
    value: function getStartAndEndTime() {
      var waypointIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (waypointIds.length >= 1) {
        var startTime = this.getWaypointFromId(waypointIds[0], 'startTime');
        var endTime = this.getWaypointFromId(waypointIds[0], 'endTime');
        var stTime = startTime && startTime.split(' ').length === 2 ? startTime.split(' ')[1] : '00:00:00';
        var etTime = endTime && endTime.split(' ').length === 2 ? endTime.split(' ')[1] : '23:59:00';
        return "".concat(stTime.substring(0, 5), " - ").concat(etTime.substring(0, 5));
      }

      return '00:00 - 23:59';
    }
  }, {
    key: "isRouteLate",
    value: function isRouteLate(route) {
      var runningTime = route.runningTime ? Number(route.runningTime) : 0;
      var timeWindow = route.timeWindow.length === 2 ? route.timeWindow : [0, 0];
      var bool1 = runningTime >= Number(timeWindow[0]) && runningTime <= Number(timeWindow[1]);
      return !bool1 || this.isRouteEarlyLate(route) ? 'route-late' : '';
    }
  }, {
    key: "isRouteEarlyLate",
    value: function isRouteEarlyLate(route) {
      var orderId = parseInt(route.masterpointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(route.masterpointId.split('-')[1], 10) || null;
      var eta = route.estimateTime;

      if (orderId && waypointIndex) {
        var order = this.$plan['orders'].filter(function (o) {
          return o['id'] === orderId;
        });

        if (!order || order.length === 0) {
          return '';
        }

        var waypoint = order[0].waypoints[waypointIndex - 1];

        if (!waypoint || waypoint.length === 0) {
          return '';
        }

        var startDuration = _moment.default.duration(route.timeWindow[0], 'seconds').as('milliseconds');

        var startTime = _moment.default.utc(startDuration).format('HH:mm:ss');

        startTime = (0, _moment.default)(waypoint.startTime).format("YYYY-MM-DD ".concat(startTime));

        var endDuration = _moment.default.duration(route.timeWindow[1], 'seconds').as('milliseconds');

        var endTime = _moment.default.utc(endDuration).format('HH:mm:ss');

        endTime = (0, _moment.default)(waypoint.startTime).format("YYYY-MM-DD ".concat(endTime));

        if (endTime.substring(11, 19) === '00:00:00') {
          endTime = (0, _moment.default)(endTime).format('YYYY-MM-DD 23:59:59');
        }

        return (0, _moment.default)(eta).diff(endTime) > 0 || (0, _moment.default)(eta).diff(startTime) < 0;
      }

      return false;
    }
  }, {
    key: "handleColorByPlanIdChange",
    value: function handleColorByPlanIdChange(data) {
      this.colorByPlanId = (0, _toConsumableArray2.default)(data);
    }
  }, {
    key: "getPlanIdColor",
    value: function getPlanIdColor(planId) {
      var color = this.helper.find(this.colorByPlanId, function (i) {
        return i.planId === planId;
      });
      return this.helper.get(color, 'color', '');
    }
  }, {
    key: "handleSelectShipRef",
    value: function () {
      var _handleSelectShipRef = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(shipRef) {
        var isExist;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isExist = this.selectedShipRefs.indexOf(shipRef);

                if (this.selectedShipRefs.length === 0 || isExist === -1) {
                  this.selectedShipRefs.push(shipRef);
                } else {
                  this.selectedShipRefs = this.selectedShipRefs.filter(function (i) {
                    return i !== shipRef;
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSelectShipRef(_x) {
        return _handleSelectShipRef.apply(this, arguments);
      }

      return handleSelectShipRef;
    }()
  }, {
    key: "selectShipRef",
    value: function selectShipRef(route) {
      var shipRefs = route.shipmentReference;
      var intersectShipRefs = this.helper.intersection(this.selectedShipRefs, shipRefs);

      if (intersectShipRefs.length === 0) {
        this.selectedShipRefs = [].concat((0, _toConsumableArray2.default)(this.selectedShipRefs), (0, _toConsumableArray2.default)(shipRefs));
      } else {
        this.selectedShipRefs = this.selectedShipRefs.filter(function (shipRef) {
          return !shipRefs.includes(shipRef);
        });
      }
    }
  }, {
    key: "transferOrder",
    value: function () {
      var _transferOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this5 = this;

        var vehiclesTo, planId, isNewPlanId, prefix, newPlanIds, toBeTransferredOrders, payload, res, invalid, m, errType, errCode, vehicles, vehiclesIds, message, invalidOrderIds, plan, removedTruckIds;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isLoading = true;

                if (!this.isTransferLoadPlanDisabled) {
                  _context2.next = 4;
                  break;
                }

                this.isLoading = false;
                return _context2.abrupt("return", false);

              case 4:
                if (this.getTruckInPlan(this.targetTruck)) {
                  vehiclesTo = [this.getTruckInPlan(this.targetTruck)];
                } else {
                  vehiclesTo = [_objectSpread({
                    routes: []
                  }, this.getTruckInfo(this.targetTruck))];
                } // generate plan id


                planId = this.targetPlanId;
                isNewPlanId = this.targetPlanId === 'newPlanId';

                if (!isNewPlanId) {
                  _context2.next = 13;
                  break;
                }

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context2.next = 11;
                return this.routeAPI.generateLoadPlanId(prefix, 1);

              case 11:
                newPlanIds = _context2.sent;
                planId = this.helper.get(newPlanIds, 'data.0', []);

              case 13:
                // get orders to be transferred
                toBeTransferredOrders = this.$plan.orders.filter(function (i) {
                  return _this5.selectedShipRefs.includes(i.shipmentReference);
                });
                payload = {
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.$defaultTime,
                  vehiclesFrom: this.$plan.trucks.filter(function (truck) {
                    return _this5.fromTrucks.includes(truck.truckId);
                  }),
                  vehiclesTo: vehiclesTo,
                  routes: toBeTransferredOrders,
                  planId: planId
                };
                _context2.next = 17;
                return this.lastMileDeliveryAPI.manualAssignTransfer(payload, {});

              case 17:
                res = _context2.sent;
                invalid = (0, _toConsumableArray2.default)(res.data['invalid'] || []);
                /*const isError = (
                  this.helper.get(res, 'error', null) === 'no solution found' ||
                  this.helper.get(res, 'error', null) === 'no vehicle found'
                );*/

                if (!((!res || res.failed || this.helper.isUndefined(res.data) || !res.data.vehiclesFrom.length || !res.data.vehiclesTo.length) && invalid.length === 0)) {
                  _context2.next = 26;
                  break;
                }

                m = {
                  title: this.$t('planning.messages.noSolution'),
                  duration: 5000
                };
                errType = this.helper.get(res, 'data.error', null);

                if (errType === 'no vehicle found') {
                  errCode = this.helper.get(res, 'data.invalidVehicles.0.code', '');
                  m = {
                    title: this.$t("planning.autoAssignInvalidCodes.".concat(errCode)),
                    duration: 5000
                  };
                }

                _elementUi.Notification.error(m);

                this.isLoading = false;
                return _context2.abrupt("return", false);

              case 26:
                this.handleInvalidRoutes({
                  res: res,
                  invalid: invalid
                });
                vehicles = [].concat((0, _toConsumableArray2.default)(this.helper.get(res, 'data.vehiclesFrom', [])), (0, _toConsumableArray2.default)(this.helper.get(res, 'data.vehiclesTo', [])));
                vehiclesIds = vehicles.map(function (t) {
                  return t.truckId;
                });

                if (vehicles.length) {
                  _context2.next = 32;
                  break;
                }

                this.isLoading = false;
                return _context2.abrupt("return", false);

              case 32:
                message = {
                  title: this.$i18n.t('planning.messages.transferSuccess'),
                  duration: 5000
                };

                if (invalid.length) {
                  message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };
                }

                if (vehicles && vehicles.length) {
                  invalidOrderIds = this.helper.get(res, 'invalidOrder', []);
                  this.$anyChanges = true;
                  plan = this.helper.cloneDeep(this.$plan);
                  plan['orders'] = plan['orders'].filter(function (o) {
                    return !invalidOrderIds.includes(o['id']);
                  });
                  plan['orderId'] = plan['orders'].map(function (o) {
                    return o.id;
                  });
                  plan['trucks'] = [].concat((0, _toConsumableArray2.default)(plan['trucks'].filter(function (t) {
                    return !vehiclesIds.includes(t.truckId);
                  })), (0, _toConsumableArray2.default)(vehicles)).filter(function (t) {
                    return t.routes.length;
                  });
                  plan['truckId'] = plan['trucks'].map(function (t) {
                    return t.truckId;
                  });
                  removedTruckIds = vehicles.filter(function (t) {
                    return !t.routes.length;
                  }).map(function (t) {
                    return Number(t.truckId);
                  });
                  this.$removedTruckIds = (0, _toConsumableArray2.default)(removedTruckIds);
                  this.$setPlan({
                    plan: plan
                  });

                  _elementUi.Notification.success(message);

                  this.logger.info('Save Transferred Plan', plan, this.$removedTruckIds);
                  this.fromTrucks = this.fromTrucks.filter(function (tId) {
                    return !_this5.$removedTruckIds.includes(tId);
                  });

                  if (this.$removedTruckIds.includes(this.$selectedTruck)) {
                    this.$selectedTruck = null;
                  }

                  this.resetData();
                  this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(this.$plan.orders.map(function (o) {
                    return o['id'];
                  })));
                  /**
                   * no need since calling saveplan
                   * */
                  // this.logger.info('transferOrder - Get Unassigned Orders');
                  // await this.$getUnassignedOrders();
                }

                _context2.next = 37;
                return this.saveTransferredPlan();

              case 37:
                this.isLoading = false;

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function transferOrder() {
        return _transferOrder.apply(this, arguments);
      }

      return transferOrder;
    }()
  }, {
    key: "handleInvalidRoutes",
    value: function handleInvalidRoutes(_ref3) {
      var res = _ref3.res,
          invalid = _ref3.invalid;

      if (!invalid.length) {
        return;
      }

      var failedOrders = invalid.map(function (irData) {
        return {
          code: irData['code'] || '',
          type: irData['type'] || '',
          reason: irData['reason'] || '',
          orderId: irData['orderId'] || [],
          shipmentReference: irData['shipmentReference'] || [],
          plateNumber: irData['plateNumber'] || [],
          vehicleId: irData['vehicleId'] || []
        };
      });
      this.$failedOrders = failedOrders || [];
    }
    /*async transferOrder() {
      this.isLoading = true;
         if (this.isTransferLoadPlanDisabled) {
        this.isLoading = false;
        return;
      }
         const oriUnassignedOrders = this.helper.cloneDeep(this.$plan.orders);
      const unassignedOrders = this.$plan.orders.filter(i => this.selectedShipRefs.includes(i.shipmentReference));
         const targetTruckObj = this.getTruckInPlan(this.targetTruck);
      let res;
      if (!targetTruckObj) {
        res = await this.assignOrderToTruck({ unassignedOrders, isEmptyTruck: true, });
      } else {
        res = await this.assignOrderToTruck({ unassignedOrders, isEmptyTruck: false, });
      }
         if (!res) {
        this.isLoading = false;
        return;
      }
         await this.updateAffectedTruckData({ oriUnassignedOrders });
         /!**
       * avoid resetting the state
       * preserve the before state
       * *!/
      // this.fromTrucks = this.fromTrucks.filter(i => this.truckIds.includes(i));
         this.logger.info('Transfer Order', {
        unassignedOrders,
        fromTrucks: this.fromTrucks,
        targetTruck: this.targetTruck,
        plan: this.$plan,
        mapPoints: this.mapPoints,
      });
         await this.saveTransferredPlan();
      this.isLoading = false;
    }
       async assignOrderToTruck({ unassignedOrders, isEmptyTruck }) {
      let res;
         const isNewPlanId = this.targetPlanId === 'newPlanId';
      let planId = this.targetPlanId;
         if (isNewPlanId) {
        const prefix = this.helper.generateNewPlanId(
          this.$userData.planIdFormat,
          this.$planDate,
          this.$userInformation,
          'lastmile'
        );
        const newPlanIds = await this.routeAPI.generateLoadPlanId(prefix, 1);
        planId = this.helper.get(newPlanIds, 'data.0', []);
      }
         if (isEmptyTruck) {
        res = await this.handleNewTruckObj({
          planId,
          truckId: this.targetTruck,
          unassignedOrders,
          isTransfer: true,
        });
      } else {
        const truckObj = this.getTruckInPlan(this.targetTruck);
        res = await this.handleExistingTruckObj({
          planId,
          isNewPlanId,
          truckObj,
          unassignedOrders,
          isTransfer: true,
        });
      }
         if (this.helper.isUndefined(res)) {
        this.isManualAssignLoading = false;
        return false;
      }
         if (res.failedOrders.length) {
        const message: ElNotificationOptions = {
          title: this.$i18n.t('planning.messages.transferFailedInvalidOrders'),
          duration: 5000,
        } as ElNotificationOptions;
        Notification.error(message);
        this.isManualAssignLoading = false;
           return false;
      }
         this.$failedOrders = this.helper.get(res, 'failedOrders', []);
      this.$anyChanges = true;
      this.isManualAssignLoading = false;
      return true;
    }
       async updateAffectedTruckData({ oriUnassignedOrders }) {
      const bufferPlan = this.helper.cloneDeep(this.$plan);
         const selectedOrderIds = bufferPlan.orders
        .filter(i => this.selectedShipRefs.includes(i.shipmentReference))
        .map(i => i.id);
         const payload = {
        code: this.$planDate,
        vehicleFrom: [],
        vehicleTo: this.getTruckInPlan(this.targetTruck),
      };
      let returnBackOrderIds = [];
         this.fromTrucks.forEach(truckId => {
        const truckObj = this.getTruckInPlan(truckId);
        const orderId = truckObj['orderId'].filter(i => !selectedOrderIds.includes(i));
           payload.vehicleFrom.push({
          truckId,
          vehicleId: truckId,
          orderId,
        });
           returnBackOrderIds = [
          ...returnBackOrderIds,
          ...orderId,
        ];
      });
         const res = await this.lastMileDeliveryAPI.transferPlan(payload);
      const data = this.helper.get(res, 'data', null);
         const message: ElNotificationOptions = {
        title: this.$i18n.t('planning.messages.transferSuccess'),
        duration: 5000,
      } as ElNotificationOptions;
         if (!data) {
        message['title'] = <string>this.$i18n.t('planning.messages.transferFailed');
        Notification.error(message);
        return false;
      }
         const affectedTruckIds = [...this.fromTrucks, this.targetTruck];
      const removeVehicleObj = data.invalid.find(i => i.type === 'removevehicle');
      const removedTruckIds = this.helper.get(removeVehicleObj, 'vehicleId', []);
      this.$removedTruckIds = [ ...removedTruckIds ];
         data.vehicles.forEach(truck => {
        const truckIndex = this.helper.findIndex(bufferPlan.trucks, t => t.truckId === truck.truckId);
        truck['hasUpdate'] = affectedTruckIds.includes(truck.truckId);
        bufferPlan.trucks[truckIndex] = this.helper.cloneDeep(truck);
      });
         bufferPlan['planId'] = data['summary']['planId'];
      bufferPlan['truckId'] = data['summary']['vehicleId'];
      bufferPlan['trucks'] = bufferPlan.trucks.filter(i => !removedTruckIds.includes(i.truckId));
         // return back orders if it being removed during the manual assign process
      const returnBackOrders = oriUnassignedOrders.filter(o => returnBackOrderIds.includes(o['id']));
      bufferPlan['orders'] = [
        ...bufferPlan['orders'],
        ...returnBackOrders,
      ];
         Notification.success(message);
      this.$setPlan({ 'plan': bufferPlan });
      this.resetData();
    }*/

  }, {
    key: "saveTransferredPlan",
    value: function saveTransferredPlan() {
      this.savePlan(this.$plan, false, true, false); // this.$emit('modalClose');
    }
  }, {
    key: "resetData",
    value: function resetData() {
      this.selectedShipRefs = [];
      this.currentPlanId = null;
      /**
       * avoid resetting the state
       * preserve the before state
       * */
      // this.targetTruck = null;
      // this.targetPlanId = 'newPlanId';

      this.initMapPoints();
    }
  }, {
    key: "getUsername",
    value: function getUsername() {
      var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.routes;
      var planId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentPlanId;
      return this.helper.get(routes.filter(function (r) {
        return r['planId'] === planId;
      }), '0.user', this.$userInformation.user.name);
    }
  }, {
    key: "handleTargetTruckChange",
    value: function handleTargetTruckChange(newVal) {
      this.targetPlanId = 'newPlanId';
      var fromPoints = this.mapPoints.filter(function (r) {
        return r.isFrom;
      });
      var toPoints = this.targetTruck ? this.getRoutes(this.targetTruck) : [];
      this.mapPoints = [].concat((0, _toConsumableArray2.default)(fromPoints), (0, _toConsumableArray2.default)(toPoints.map(function (r) {
        return _objectSpread(_objectSpread({}, r), {}, {
          isFrom: false
        });
      })));
      this.refreshMap(); // Socket for global trucks

      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: [].concat((0, _toConsumableArray2.default)(this.fromTrucks), [newVal])
      });
    }
  }, {
    key: "handleFromTrucksChange",
    value: function handleFromTrucksChange(newVal) {
      var _this6 = this;

      var fromPoints = [];
      var toPoints = this.mapPoints.filter(function (r) {
        return !r.isFrom;
      });
      newVal.forEach(function (truckId) {
        fromPoints.push.apply(fromPoints, (0, _toConsumableArray2.default)(_this6.getRoutes(truckId).map(function (r) {
          return _objectSpread(_objectSpread({}, r), {}, {
            isFrom: true,
            truckId: truckId
          });
        })));
      });
      this.mapPoints = [].concat(fromPoints, (0, _toConsumableArray2.default)(toPoints));
      this.refreshMap();
      this.selectedShipRefs = []; // Socket for global trucks

      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: [].concat((0, _toConsumableArray2.default)(newVal), [this.targetTruck])
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      if (this.helper.isEmptyObject(this.location) && this.fromTrucks.length) {
        var truckData = this.getRoutes(this.fromTrucks[0]);
        this.location = {
          latitude: Number(truckData[0]['latitude']),
          longitude: Number(truckData[0]['longitude'])
        };
      }

      if (this.$refs.mapWorld) {
        this.$refs.mapWorld.refreshMap(this.mapPoints, {
          planId: this.currentPlanId
        });
      }
    }
  }, {
    key: "redrawMarkerOnly",
    value: function redrawMarkerOnly() {
      if (this.$refs.mapWorld) {
        this.$refs.mapWorld.clearMarker();
        this.$refs.mapWorld.initPolyline(this.mapPoints, this.currentPlanId, true);
      }
    }
  }, {
    key: "initMapPoints",
    value: function initMapPoints() {
      var _this7 = this;

      var toPoints = this.targetTruck ? this.getRoutes(this.targetTruck) : [];
      this.mapPoints = [];
      this.fromTrucks.forEach(function (truckId) {
        var _this7$mapPoints;

        var massagedRoutes = _this7.getRoutes(truckId).map(function (r) {
          return _objectSpread(_objectSpread({}, r), {}, {
            isFrom: true,
            truckId: truckId
          });
        });

        (_this7$mapPoints = _this7.mapPoints).push.apply(_this7$mapPoints, (0, _toConsumableArray2.default)(massagedRoutes));
      });
      this.mapPoints = [].concat((0, _toConsumableArray2.default)(this.mapPoints), (0, _toConsumableArray2.default)(toPoints.map(function (r) {
        return _objectSpread(_objectSpread({}, r), {}, {
          isFrom: false
        });
      })));
    }
  }, {
    key: "initMap",
    value: function initMap(truckData) {
      if (truckData[0] && truckData[0]['latitude'] && truckData[0]['longitude']) {
        this.location = {
          latitude: Number(truckData[0]['latitude']),
          longitude: Number(truckData[0]['longitude'])
        };
      }

      this.initMapPoints();
      this.refreshMap();
    }
  }, {
    key: "isNotToTrucks",
    value: function isNotToTrucks(truckId) {
      return this.targetTruck ? truckId !== this.targetTruck : true;
    }
  }, {
    key: "removeOrders",
    value: function () {
      var _removeOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this8 = this;

        var payload, assignedOrderShipRefs, filteredTrucks, cancelDriverAssignmentPayload, m, cancelDriverAssignmentRes, res, data, message, removeVehicleObj, removedTruckIds, bufferPlan, selectedOrders, dOrders, dOrderIds;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isRemoveOrdersDisabled) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                payload = {
                  code: this.$planDate,
                  vehicle: []
                };
                assignedOrderShipRefs = [];
                filteredTrucks = this.$plan.trucks.filter(function (truck) {
                  return _this8.fromTrucks.includes(truck.truckId);
                });
                filteredTrucks.forEach(function (truck) {
                  var bool = _this8.helper.some(truck.routes, function (r) {
                    var intersect = _this8.helper.intersection(r.shipmentReference, _this8.selectedShipRefs);

                    return intersect.length > 0;
                  });

                  if (bool) {
                    var truckShipRefs = _this8.helper.uniq(_this8.helper.flatten(truck.routes.map(function (r) {
                      return r.shipmentReference;
                    })));

                    var deletedShipRef = _this8.helper.intersection(truckShipRefs, _this8.selectedShipRefs);

                    var deletedOrders = _this8.$plan.orders.filter(function (o) {
                      return deletedShipRef.includes(o.shipmentReference);
                    });

                    var deletedOrderIds = deletedOrders.map(function (o) {
                      return o.id;
                    });

                    var truckAssignedShipRefs = _this8.helper.uniq(_this8.helper.flatten(truck.routes.filter(function (r) {
                      return r.status.toUpperCase() === 'ASSIGNED';
                    }).map(function (r) {
                      return r.shipmentReference;
                    })));

                    var deletedAssignedShipRef = _this8.helper.intersection(truckAssignedShipRefs, _this8.selectedShipRefs);

                    payload.vehicle.push({
                      truckId: truck.truckId,
                      vehicleId: truck.truckId,
                      orderId: deletedOrderIds
                    });
                    assignedOrderShipRefs = [].concat((0, _toConsumableArray2.default)(assignedOrderShipRefs), (0, _toConsumableArray2.default)(deletedAssignedShipRef));
                  }
                }); // Unassign order(s) from driver

                if (!(assignedOrderShipRefs.length > 0)) {
                  _context3.next = 21;
                  break;
                }

                cancelDriverAssignmentPayload = [];
                this.helper.forEach(assignedOrderShipRefs, function (order) {
                  cancelDriverAssignmentPayload.push({
                    shipref: order
                  });
                });
                m = {
                  title: this.$i18n.t('planning.messages.unassignFailed'),
                  duration: 5000
                };

                if (!(cancelDriverAssignmentPayload.length === 0)) {
                  _context3.next = 14;
                  break;
                }

                m['title'] = this.$i18n.t('planning.messages.noOrdersToUnassign');

                _elementUi.Notification.warning(m);

                return _context3.abrupt("return");

              case 14:
                _context3.next = 16;
                return this.cancelDriverAssignment(cancelDriverAssignmentPayload);

              case 16:
                cancelDriverAssignmentRes = _context3.sent;

                if (cancelDriverAssignmentRes) {
                  _context3.next = 20;
                  break;
                }

                _elementUi.Notification.warning(m);

                return _context3.abrupt("return");

              case 20:
                this.logger.info('Unassign orders from multiple trucks payload', payload);

              case 21:
                _context3.next = 23;
                return this.lastMileDeliveryAPI.removeOrder(payload);

              case 23:
                res = _context3.sent;
                data = this.helper.get(res, 'data', null);
                message = {
                  title: this.$i18n.t('planning.messages.removeOrderSuccess'),
                  duration: 5000
                };

                if (data) {
                  _context3.next = 30;
                  break;
                }

                message['title'] = this.$i18n.t('planning.messages.removeOrderFailed');

                _elementUi.Notification.error(message);

                return _context3.abrupt("return", false);

              case 30:
                removeVehicleObj = data.invalid.find(function (i) {
                  return i.type === 'removevehicle';
                });
                removedTruckIds = this.helper.get(removeVehicleObj, 'vehicleId', []);
                this.$removedTruckIds = (0, _toConsumableArray2.default)(removedTruckIds);
                bufferPlan = this.helper.cloneDeep(this.$plan);
                selectedOrders = bufferPlan['orders'].filter(function (o) {
                  return !_this8.selectedShipRefs.includes(o.shipmentReference);
                });
                dOrders = bufferPlan['orders'].filter(function (o) {
                  return _this8.selectedShipRefs.includes(o.shipmentReference);
                });
                dOrderIds = dOrders.map(function (o) {
                  return o.id;
                });
                bufferPlan['orders'] = selectedOrders;
                bufferPlan['orderId'] = bufferPlan['orders'].map(function (i) {
                  return i.id;
                });
                data['vehicles'].forEach(function (i) {
                  var truckIndex = bufferPlan['trucks'].findIndex(function (t) {
                    return t.truckId === i.truckId;
                  });

                  if (truckIndex !== -1) {
                    bufferPlan['trucks'][truckIndex] = i;
                  }
                });

                if (this.$removedTruckIds.length > 0) {
                  bufferPlan['trucks'] = bufferPlan['trucks'].filter(function (i) {
                    return !_this8.$removedTruckIds.includes(i.truckId);
                  });
                }

                bufferPlan['truckId'] = bufferPlan['trucks'].map(function (i) {
                  return i.truckId;
                });
                bufferPlan['planId'] = this.helper.flatten(bufferPlan['trucks'].map(function (i) {
                  return i.planId;
                }));
                this.$includedOrders = [].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(dOrderIds));
                this.logger.info('removeOrders - Get Unassigned Orders');
                _context3.next = 47;
                return this.$getUnassignedOrders();

              case 47:
                this.$anyChanges = true;

                _elementUi.Notification.success(message);

                this.$setPlan({
                  'plan': bufferPlan
                });
                this.handleModalClose();
                this.resetData(); // if (assignedOrderShipRefs.length > 0) {

                _context3.next = 54;
                return this.savePlan(this.$plan);

              case 54:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeOrders() {
        return _removeOrders.apply(this, arguments);
      }

      return removeOrders;
    }()
  }, {
    key: "handleRouteDrag",
    value: function () {
      var _handleRouteDrag = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
        var oldIndex, newIndex;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                oldIndex = e.moved.oldIndex;
                newIndex = e.moved.newIndex;
                this.routeIndex = newIndex < oldIndex ? newIndex : oldIndex;
                _context4.next = 5;
                return this.updateETA();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleRouteDrag(_x2) {
        return _handleRouteDrag.apply(this, arguments);
      }

      return handleRouteDrag;
    }()
  }, {
    key: "updateETA",
    value: function () {
      var _updateETA = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this9 = this;

        var payload, calculateEta;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                payload = {
                  routes: this.helper.cloneDeep(this.mapPoints.filter(function (i) {
                    return i.planId === _this9.currentPlanId;
                  })),
                  startTime: null,
                  index: this.routeIndex >= 1 ? this.routeIndex - 1 : this.routeIndex
                };
                _context5.next = 3;
                return this.calculateETA(payload, 'REORDER');

              case 3:
                calculateEta = _context5.sent;

                if (calculateEta) {
                  this.updateCurrentTruck(calculateEta);
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateETA() {
        return _updateETA.apply(this, arguments);
      }

      return updateETA;
    }()
  }, {
    key: "drawPolygon",
    value: function drawPolygon() {
      this.selectedShipRefs = [];

      if (this.$refs.mapWorld) {
        this.$refs.mapWorld.drawPolygonTransferPlan('#fde85d');
      }
    }
  }, {
    key: "handlePolygonComplete",
    value: function handlePolygonComplete(shipRefs) {
      this.selectedShipRefs = (0, _toConsumableArray2.default)(shipRefs);
    }
  }, {
    key: "getPlateNumber",
    value: function getPlateNumber(_ref4) {
      var route = _ref4.route;

      if (!route) {
        return '';
      }

      return this.helper.get(this.getTruckInfo(route.truckId), 'plateNumber', '');
    }
  }, {
    key: "isShowPlateNumber",
    value: function isShowPlateNumber(_ref5) {
      var route = _ref5.route,
          routeIndex = _ref5.routeIndex;
      var plateNumber = this.getPlateNumber({
        route: route
      });

      if (this.helper.isUndefined(plateNumber)) {
        return false;
      }

      if (routeIndex === 0) {
        return true;
      }

      var prevRoute = this.mapPoints[routeIndex - 1];

      if (!prevRoute || !prevRoute.isFrom) {
        return false;
      }

      var prevPlateNumber = this.getPlateNumber({
        route: prevRoute
      });
      return prevPlateNumber !== plateNumber;
    }
  }]);
  return LMDTransferOrderModalComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryPricerite.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LMDTransferOrderModalComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTransferOrderModalComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTransferOrderModalComponent.prototype, "isVisible", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isVisible', {
  immediate: true
})], LMDTransferOrderModalComponent.prototype, "onVisibilityChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routes', {
  deep: true
})], LMDTransferOrderModalComponent.prototype, "onRoutesChange", null);
LMDTransferOrderModalComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDTransferOrderModalComponent',
  components: {
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-dialog': _elementUi.Dialog,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'draggable': _vuedraggable.default
  }
})], LMDTransferOrderModalComponent);
var _default = LMDTransferOrderModalComponent;
exports.default = _default;